import React from 'react';
import ReactDOM from 'react-dom';
import './style.css';
import AppComponent from './modules/app-component';
/* import registerServiceWorker from './registerServiceWorker'; */

ReactDOM.render(<AppComponent />, document.getElementById('root'));
/* registerServiceWorker(); */
